






import FilledLogo from '@/assets/images/logo/bambee-filled.svg?inline';
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'WelcomeMessage',
  components: {
    FilledLogo,
  },
});
